var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Modal as AntdModal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
var StyledModal = styled(AntdModal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && .ant-modal-close {\n    top: 10px;\n    right: 2px;\n  }\n"], ["\n  && .ant-modal-close {\n    top: 10px;\n    right: 2px;\n  }\n"])));
export var Modal = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, position = _a.position, footerMargin = _a.footerMargin, height = _a.height, overflowY = _a.overflowY, maxHeight = _a.maxHeight, padding = _a.padding, userStyles = _a.styles, destroyOnClose = _a.destroyOnClose, width = _a.width, restProps = __rest(_a, ["children", "variant", "position", "footerMargin", "height", "overflowY", "maxHeight", "padding", "styles", "destroyOnClose", "width"]);
    var isWide = variant === 'wide';
    // Create modal styles based on variant
    var modalStyles = React.useMemo(function () {
        if (isWide) {
            return {
                mask: __assign({ backgroundColor: 'rgba(143, 147, 156, 0.4)' }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.mask),
                header: __assign({ display: 'none' }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.header),
                container: __assign({ height: '100%', padding: padding !== null && padding !== void 0 ? padding : 0, maxHeight: '94vh', overflowY: 'auto' }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.container),
                body: __assign({ padding: 0, margin: 0 }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.body),
                footer: __assign({ display: 'none' }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.footer)
            };
        }
        return {
            container: __assign({ boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', borderRadius: '16px', padding: 0 }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.container),
            mask: __assign({ backgroundColor: 'rgba(143, 147, 156, 0.4)' }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.mask),
            header: __assign({ padding: '16px 24px', borderRadius: '16px 16px 0 0', borderBottom: '1px solid #f0f0f0' }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.header),
            body: __assign({ padding: padding !== null && padding !== void 0 ? padding : '24px', position: (position || 'relative'), height: height || 'auto', maxHeight: maxHeight !== null && maxHeight !== void 0 ? maxHeight : '66.6vh', overflowY: (overflowY || 'auto') }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.body),
            footer: __assign({ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '12px 24px', margin: footerMargin !== null && footerMargin !== void 0 ? footerMargin : 0, border: 'none', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }, userStyles === null || userStyles === void 0 ? void 0 : userStyles.footer)
        };
    }, [
        isWide,
        position,
        height,
        maxHeight,
        overflowY,
        padding,
        footerMargin,
        userStyles
    ]);
    return (_jsx(StyledModal, __assign({}, restProps, { width: width !== null && width !== void 0 ? width : (isWide ? '90%' : undefined), styles: modalStyles, closeIcon: _jsx(CloseOutlined, { "data-test": "closeModalBtn" }), destroyOnHidden: destroyOnClose, mask: { enabled: true, blur: false }, children: children })));
};
// Backwards compatibility alias
export var ModalWide = function (props) { return (_jsx(Modal, __assign({}, props, { variant: "wide" }))); };
export default Modal;
var templateObject_1;
